import React from 'react';
import { useGetMembersQuery } from '../redux/features/members/memberApi';
import Member from './Member';

const TeamMembersList = () => {
  const {data,isError,isLoading}=useGetMembersQuery() || {};
 
  let content=null;
if(isLoading){
  content =<p>Loading...........</p>
}
else if(!isLoading && isError ){
  content =<p>Something went wrong !</p>
}
else if(!isLoading && !isError && data?.length > 0){

  
  content = data?.map(member=>  <Member member={member} key={member.id}/>)
}

  return (
    <div><div className="mt-8">
    <h3 className="text-xl font-bold">Team Members</h3>
    <div className="mt-3 space-y-4">
   {content}
     
    </div>
  </div></div>
  )
}

export default TeamMembersList